export const apiURL =   {
    ASR_OFFLINE : 'https://pub.zb-tech.com/asr/offline',           // 获取离线语音识别结果
    ASR_COLLECT_ENV : 'https://pub.zb-tech.com/asr/collectEnv',    // 采集环境噪音
    ASR_STOP_RECORD : 'https://pub.zb-tech.com/asr/stopRecord',    // 后端暂停录音
    ASR_RESUME_RECORD : 'https://pub.zb-tech.com/asr/resumeRecord',// 后端恢复录音

    NLP_CHAT : 'https://pub.zb-tech.com/nlp/chat',                 // NLP闲聊接口
    NLP_IE : 'https://pub.zb-tech.com/nlp/ie',                     // 信息抽取接口

    TTS_OFFLINE : 'https://pub.zb-tech.com/tts/offline',           // 获取TTS音频

    VPR_RECOG : 'https://pub.zb-tech.com/vpr/recog',               // 声纹识别接口，返回声纹对比相似度
    VPR_ENROLL : 'https://pub.zb-tech.com/vpr/enroll',             // 声纹识别注册接口
    VPR_LIST : 'https://pub.zb-tech.com/vpr/list',                 // 获取声纹注册的数据列表
    VPR_DEL : 'https://pub.zb-tech.com/vpr/del',                   // 删除用户声纹
    VPR_DATA : 'https://pub.zb-tech.com/vpr/database64?vprId=',            // 获取声纹注册数据 bs64格式

    // websocket
    CHAT_SOCKET_RECORD: 'ws://pub.zb-tech.com:8010/ai/ws/asr/offlineStream', // ChatBot websocket 接口
    ASR_SOCKET_RECORD: 'ws://pub.zb-tech.com:8010/ai/ws/asr/onlineStream',  // Stream ASR 接口
    TTS_SOCKET_RECORD: 'ws://pub.zb-tech.com:8010/ai/ws/tts/online', // Stream TTS 接口

    // voice clone
    // Voice Clone
    VC_List: 'https://pub.zb-tech.com/vc/list',
    SAT_List: 'https://pub.zb-tech.com/sat/list',
    FineTune_List: 'https://pub.zb-tech.com/finetune/list',

    VC_Upload: 'https://pub.zb-tech.com/vc/upload',
    SAT_Upload: 'https://pub.zb-tech.com/sat/upload',
    FineTune_Upload: 'https://pub.zb-tech.com/finetune/upload',
    FineTune_NewDir: 'https://pub.zb-tech.com/finetune/newdir',

    VC_Download: 'https://pub.zb-tech.com/vc/download',
    VC_Download_Base64: 'https://pub.zb-tech.com/vc/download_base64',
    VC_Del: 'https://pub.zb-tech.com/vc/del',
    
    VC_CloneG2p: 'https://pub.zb-tech.com/vc/clone_g2p',
    VC_CloneSAT: 'https://pub.zb-tech.com/vc/clone_sat',
    VC_CloneFineTune: 'https://pub.zb-tech.com/finetune/clone_finetune',
    VC_CloneFineTuneSyn: 'https://pub.zb-tech.com/finetune/clone_finetune_syn',
}







